/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {EventFamilyInfo} from '../models/EventFamilyInfo';
import type {SaveEventFamilyRequest} from '../models/SaveEventFamilyRequest';

export interface GetAllEventFamilies$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAllEventFamiliesRequest = createAction<PayloadData<void>>('EVENT_FAMILY_CONTROLLER__GET_ALL_EVENT_FAMILIES__REQUEST');
export const getAllEventFamiliesSuccess = createAction<PayloadData<Array<EventFamilyInfo>>>('EVENT_FAMILY_CONTROLLER__GET_ALL_EVENT_FAMILIES__SUCCESS');
export const getAllEventFamiliesFailure = createAction<PayloadData<Error, void, true>>('EVENT_FAMILY_CONTROLLER__GET_ALL_EVENT_FAMILIES__FAILURE');

export const getAllEventFamiliesActions = [
    getAllEventFamiliesRequest,
    getAllEventFamiliesSuccess,
    getAllEventFamiliesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAllEventFamilies = (config?: GetAllEventFamilies$Config) => {
    return {
        CALL_API: {
            types: getAllEventFamiliesActions,
            method: ApiMethods.GET,
            endpoint: `/event-families`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface RemoveEventFamilyByName$Request {
    name: string;
}

export interface RemoveEventFamilyByName$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeEventFamilyByNameRequest = createAction<PayloadData<void, RemoveEventFamilyByName$Request>>('EVENT_FAMILY_CONTROLLER__REMOVE_EVENT_FAMILY_BY_NAME__REQUEST');
export const removeEventFamilyByNameSuccess = createAction<PayloadData<void, RemoveEventFamilyByName$Request>>('EVENT_FAMILY_CONTROLLER__REMOVE_EVENT_FAMILY_BY_NAME__SUCCESS');
export const removeEventFamilyByNameFailure = createAction<PayloadData<Error, RemoveEventFamilyByName$Request, true>>('EVENT_FAMILY_CONTROLLER__REMOVE_EVENT_FAMILY_BY_NAME__FAILURE');

export const removeEventFamilyByNameActions = [
    removeEventFamilyByNameRequest,
    removeEventFamilyByNameSuccess,
    removeEventFamilyByNameFailure
] as const;

/**
 * @param {string} meta.name Event Family name
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeEventFamilyByName = (meta: RemoveEventFamilyByName$Request, config?: RemoveEventFamilyByName$Config) => {
    return {
        CALL_API: {
            types: removeEventFamilyByNameActions,
            method: ApiMethods.DELETE,
            endpoint: `/event-families/remove/${meta.name}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveEventFamily$Request {
    saveEventFamilyRequest: SaveEventFamilyRequest;
}

export interface SaveEventFamily$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveEventFamilyRequest = createAction<PayloadData<void, SaveEventFamily$Request>>('EVENT_FAMILY_CONTROLLER__SAVE_EVENT_FAMILY__REQUEST');
export const saveEventFamilySuccess = createAction<PayloadData<void, SaveEventFamily$Request>>('EVENT_FAMILY_CONTROLLER__SAVE_EVENT_FAMILY__SUCCESS');
export const saveEventFamilyFailure = createAction<PayloadData<Error, SaveEventFamily$Request, true>>('EVENT_FAMILY_CONTROLLER__SAVE_EVENT_FAMILY__FAILURE');

export const saveEventFamilyActions = [
    saveEventFamilyRequest,
    saveEventFamilySuccess,
    saveEventFamilyFailure
] as const;

/**
 * @param {SaveEventFamilyRequest} meta.saveEventFamilyRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveEventFamily = (meta: SaveEventFamily$Request, config?: SaveEventFamily$Config) => {
    return {
        CALL_API: {
            types: saveEventFamilyActions,
            method: ApiMethods.POST,
            endpoint: `/event-families/save`,
            TRANSPORT_REQUEST_BODY: meta.saveEventFamilyRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

